import {
  Paper,
  TextField,
  Grid,
  MenuItem,
  Button,
  stepButtonClasses,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserById, updateUserById } from "../../api/user";
import { role } from "../../config/roles";
import useSnackbar from "../../hooks/useSnackbar.js";
import useErrorHandler from "../../hooks/useErrorHandler";

export default function UserDetail() {
  const { data: user } = useSelector((state) => state.user);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();

  const [userData, setUserData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    role: "",
    city: "",
    state: "",
    zipcode: "",
    address: "",
    address2: "",
    country: "",
  });

  const [editDisabled, setEditDisabled] = useState(true);

  useEffect(() => {
    if (!user.token) return;
    getUserById(user.token, params.id)
      .then(({ data }) => {
        setUserData(extractUserData(data.data));
      })
      .catch((err) => {
        errorHandler(err);
      });
  }, [user.token]);

  function onDetailsChange({ target }) {
    setUserData((prev) => ({ ...prev, [target.name]: target.value }));
  }
  const [phoneError, setPhoneError] = useState("");

  async function onProfileUpdate(e) {
    e.preventDefault();
    if (userData.phone.length !== 10) {
      setPhoneError("Please enter a valid 10-digit phone number");
      return;
    }
    setPhoneError("");
    try {
      await updateUserById(
        user.token,
        params.id,
        getUpdatableProfileData(userData)
      );

      snackbar.showSuccess("User Updated");
      setEditDisabled(true);
      navigate("/users");
    } catch (error) {
      errorHandler(error);
    }
  }

  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
          mb={0}
        >
          <Typography className="heading-title">User Details</Typography>
        </Box>
        {/* {user.roles === "REGISTRAR" ? (
          <></>
        ) : ( */}

        {/* )} */}

        <Box component="form" onSubmit={onProfileUpdate} sx={{ px: 2, pb: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="First Name"
                name="firstname"
                value={userData.firstname}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Last Name"
                name="lastname"
                required
                value={userData.lastname}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                type="tel"
                inputProps={{ maxLength: 10 }}
                disabled={editDisabled}
                label="Phone"
                name="phone"
                value={userData.phone}
                required
                error={!!phoneError}
                helperText={phoneError}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                type="email"
                disabled={true}
                label="Email"
                name="email"
                value={userData.email}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Role"
                name="role"
                value={userData.role}
                select
                required
              >
                {role
                  .filter((r) => {
                    return user.roles === "REGISTRAR"
                      ? r.Type === "USER"
                      : r.Type;
                  })
                  .map((data, key) => (
                    <MenuItem
                      key={key}
                      value={data.Type}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {data.Type}
                    </MenuItem>
                  ))}
                {/* <MenuItem value="ADMIN">Admin</MenuItem>
                        <MenuItem value="REGISTRAR">Registrar</MenuItem>
                        <MenuItem value="USER">User</MenuItem> */}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Address"
                name="address"
                value={userData.address}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Address Line 2"
                name="address2"
                value={userData.address2}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="City"
                name="city"
                value={userData.city}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="State"
                name="state"
                value={userData.state}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Zipcode"
                name="zipcode"
                value={userData.zipcode}
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onDetailsChange}
                disabled={editDisabled}
                label="Country"
                name="country"
                value={userData.country}
                required
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                {editDisabled ? (
                  <></>
                ) : (
                  <Button
                    size="large"
                    variant="contained"
                    color="warning"
                    type="submit"
                    className="blue-button"
                    // onClick={onProfileUpdate}
                  >
                    Save
                  </Button>
                )}

                <Button
                  size="large"
                  variant="outlined"
                  className="black-border-button"
                  disabled={/^trial_user$/i.test(user.roles) ? true : false}
                  onClick={() => setEditDisabled((prev) => !prev)}
                >
                  {editDisabled ? "Edit" : "Cancel"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}

function extractUserData(data) {
  return {
    firstname: data.firstname || "",
    lastname: data.lastname || "",
    email: data.email || "",
    phone: data.phone || "",
    role: data.role || "",
    city: data.city || "",
    state: data.state || "",
    zipcode: data.zipcode || "",
    address: data.address || "",
    address2: data.address2 || "",
    country: data.country || "",
  };
}

function getUpdatableProfileData(data) {
  return {
    firstname: data.firstname,
    lastname: data.lastname,
    phone: data.phone,
    role: data.role,
    city: data.city,
    state: data.state,
    zipcode: data.zipcode,
    address: data.address,
    address2: data.address2,
    country: data.country,
  };
}
